module.exports = __webpack_public_path__ + "img/confort.ecfa64f9.svg";